module.exports = __webpack_public_path__ + "c8f389a095f756c56133ab1b259fd9fd.svg";